/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AggregatesListingPriceCardMeQueryVariables = {||};
export type AggregatesListingPriceCardMeQueryResponse = {|
  +me: ?{|
    +isAdmin: ?boolean
  |}
|};
export type AggregatesListingPriceCardMeQuery = {|
  variables: AggregatesListingPriceCardMeQueryVariables,
  response: AggregatesListingPriceCardMeQueryResponse,
|};
*/


/*
query AggregatesListingPriceCardMeQuery {
  me {
    isAdmin
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAdmin",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AggregatesListingPriceCardMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AggregatesListingPriceCardMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "8d6bd844221660c0a9f58cdd2bd95e34",
    "id": null,
    "metadata": {},
    "name": "AggregatesListingPriceCardMeQuery",
    "operationKind": "query",
    "text": "query AggregatesListingPriceCardMeQuery {\n  me {\n    isAdmin\n    id\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4d92e1768e2eec8427b9476db52548cd';

export default node;
